import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getTags = ({ pageNumber, onResponse, onError }) => {
  fetch(
    `/api/tags/?page_number=${pageNumber}`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
